import { ReactNode } from 'react';

interface AboutItem {
  icon: ReactNode;
  title: string;
  description: string;
}

export const AboutItem = ({ icon, title, description }: AboutItem) => {
  return (
    <div className='flex flex-col items-center gap-3 w-64 h-52 p-4 bg-background-dark-subdued rounded-lg shadow-md border border-stroke-on-dark-subdued'>
      <div className='flex items-center w-full gap-2'>
        {icon}
        <h2 className='font-semibold text-[18px]'>
          {title}
        </h2>
      </div>
      <div className='text-[14px] text-content-on-dark-subdued'>
        {description}
      </div>
    </div>
  );
};
